module.exports = __webpack_public_path__ + "media/images/spinner-9ee92119.gif";